import './history-points-wrapper.scss'

import { Skeleton } from '@acctglobal/skeleton'
import React, { useCallback, useEffect, useState } from 'react'

import { ButtonHistoryPoints } from './components/ButtonHistoryPoints'
import { FilterHistoryPoints } from './components/FilterHistoryPoints'
import { HistoryPoints } from './components/HistoryPoints'
import { getMonthBoundariesInUTC } from '../../../../../utils/date/getMonthBoundariesInUTC'
import { PointsIcon } from '../../../../assets/PointsIcon'
import { useCardContext } from '../../../../contexts/CardContext'
import useWindowDimensions from '../../../../hooks/useWindowDimensions'
import { DynamicTitle } from '../../../common/DynamicTitle'
import { StatusMessage } from '../../../ui/StatusMessage'

import type { Balance } from '../../../../contexts/CardContext'
import type { SeeMoreTextHistoryPoints } from '../../../../types/ClubCard/ClubCardUser'

interface HistoryPointsWrapperProps {
  visibility: boolean
  title: string
  text?: string
  seeMoreText?: SeeMoreTextHistoryPoints
  balance?: Balance
  isFilter?: boolean
}

export const HistoryPointsWrapper = ({
  visibility,
  title,
  text,
  seeMoreText,
  balance,
  isFilter,
}: HistoryPointsWrapperProps) => {
  const [filterHistoryPoints, setFilterHistoryPoints] = useState<number>()
  const { width } = useWindowDimensions()
  const { historyPoints, getHistoryPoints } = useCardContext()
  const isWidthMobile = !!width && width <= 768

  if (
    !visibility ||
    (seeMoreText && !seeMoreText?.desktop?.text) ||
    (seeMoreText && !seeMoreText?.mobile?.text)
  ) {
    return null
  }

  const fetchGetHistoryPoints = useCallback(async () => {
    if (isFilter && filterHistoryPoints !== undefined) {
      const newDateToFilter = getMonthBoundariesInUTC(
        filterHistoryPoints,
        filterHistoryPoints
      )

      await getHistoryPoints?.({
        initialDate: newDateToFilter?.firstDate,
        finalDate: newDateToFilter?.lastDate,
        pageSize: '100',
        pageNumber: '1',
      })
    }
  }, [isFilter, filterHistoryPoints])

  useEffect(() => {
    fetchGetHistoryPoints()
  }, [fetchGetHistoryPoints])

  if (historyPoints?.error || balance?.error) {
    return (
      <>
        <div className="club-card-user-history-points-wrapper grid-content">
          <div className="club-card-user-history-points-wrapper-container">
            {title && (
              <DynamicTitle
                className="history-points-title"
                titleLevel={2}
                title={title}
              />
            )}
            <StatusMessage />
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="club-card-user-history-points-wrapper grid-content">
        <div className="club-card-user-history-points-wrapper-container">
          {title && (
            <DynamicTitle
              className="history-points-title"
              titleLevel={2}
              title={title}
            />
          )}
          {text && (
            <DynamicTitle
              className="history-points-subTitle"
              titleLevel={3}
              title={text}
            />
          )}
          {balance !== undefined && (
            <div className="history-points-quantity">
              <p className="history-points-quantity-text">Saldo total:</p>
              <div className="history-points-quantity-total">
                {balance?.loading ? (
                  <Skeleton
                    width={100}
                    height={28}
                    margin={0}
                    backgroundColor="var(--color-grayScale-faded)"
                  />
                ) : (
                  <>
                    <p className="history-points-quantity-total-text">
                      {balance?.data?.toLocaleString('pt-BR') ?? '0'}
                    </p>
                    <PointsIcon />
                  </>
                )}
              </div>
            </div>
          )}
          {isFilter && (
            <FilterHistoryPoints
              filter={filterHistoryPoints}
              setFilter={setFilterHistoryPoints}
              isLoading={historyPoints?.loading}
            />
          )}
          <HistoryPoints />
          {seeMoreText &&
            historyPoints?.data &&
            historyPoints?.data?.length > 0 && (
              <ButtonHistoryPoints
                text={
                  isWidthMobile
                    ? seeMoreText?.mobile?.text
                    : seeMoreText?.desktop?.text
                }
                href="/cartao/historico-de-pontos"
              />
            )}
        </div>
      </div>
    </>
  )
}
